'use client';

import { FC } from 'react';
import { Copyright } from 'organisms/Footer/Copyright';
import { Navigation } from 'organisms/Footer/Navigation';
import { Payment } from 'organisms/Footer/Payment';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';
import styles from './styles.module.css';

export const Footer: FC = () => {
  const { footer } = useSiteConfig();

  return (
    footer && (
      <footer className={styles.root}>
        <div className={styles.container}>
          <Navigation />
          <div className={styles.divider} />
          <Payment />
          <Copyright />
        </div>
      </footer>
    )
  );
};
